import * as React from "react";
import { useState } from "react";
import { Lightbox } from "../../../../../../../react-core/Html/Components/Lightbox";
import { RelationshipType } from "../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { OrganisationMember } from "../../../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { OrganisationMemberPopUpInfo, RelationshipTypeMap } from "../../../AddClient/Resource/Contents";
import {
    checkTrusteeIsSmallerThanSettlor,
    checkFinalRelationship,
    checkSettlorEqualOrGreaterThanTwo,
} from "./TrustMemberHelper";

interface IEditRolesLightbox {
    data: OrganisationMember[];
    editItem: OrganisationMember;
    onClose: () => void;
    onSave: (customerid: OrganisationMember, newRelationships: RelationshipType[]) => void;
}

const getCheckboxOptions = (
    originData: OrganisationMember[],
    editItem: OrganisationMember,
    selectedRoles: RelationshipType[],
    setSelectedRoles,
    setIsSettlorAdded,
    setIsTrusteeSmallerThanSettlor,
    setIsRemoveFinalSettlor,
    setIsRemoveFinalBeneficiary,
    isLastTrustee: boolean,
    isTwoSettlors: boolean
) => {
    const relationships = editItem?.Relationships || [];
    if (relationships.length === 0) {return [];}
    if (relationships.length === 1) {
        // Trustee only or settlor only
        const relationship = relationships[0];
        if (relationship == RelationshipType.IndividualTrustee) {
            // Trustee only
            return [
                {
                    label: RelationshipTypeMap[RelationshipType.IndividualTrustee],
                    disabled: true,
                    value: selectedRoles.includes(RelationshipType.IndividualTrustee),
                    onChange: (v) => {},
                },
                {
                    label: RelationshipTypeMap[RelationshipType.Settlor],
                    disabled:
                        (selectedRoles.length >= 2 && !selectedRoles.includes(RelationshipType.Settlor)) ||
                        isTwoSettlors,
                    value: selectedRoles.includes(RelationshipType.Settlor),
                    onChange: (v) => {
                        if (v) {
                            setIsSettlorAdded(true);
                            selectedRoles = selectedRoles.concat(RelationshipType.Settlor);
                            setSelectedRoles(selectedRoles);
                            setIsTrusteeSmallerThanSettlor(checkTrusteeIsSmallerThanSettlor(originData, selectedRoles));
                            setIsRemoveFinalSettlor(
                                checkFinalRelationship(originData, selectedRoles, RelationshipType.Settlor)
                            );
                        } else {
                            setIsSettlorAdded(false);
                            selectedRoles = selectedRoles.filter((ele) => ele != RelationshipType.Settlor);
                            setSelectedRoles(selectedRoles);
                            setIsTrusteeSmallerThanSettlor(checkTrusteeIsSmallerThanSettlor(originData, selectedRoles));
                            setIsRemoveFinalSettlor(
                                checkFinalRelationship(originData, selectedRoles, RelationshipType.Settlor)
                            );
                        }
                    },
                },
                {
                    label: RelationshipTypeMap[RelationshipType.Beneficiary],
                    disabled: selectedRoles.length >= 2 && !selectedRoles.includes(RelationshipType.Beneficiary),
                    value: selectedRoles.includes(RelationshipType.Beneficiary),
                    onChange: (v) => {
                        if (v) {
                            selectedRoles = selectedRoles.concat(RelationshipType.Beneficiary);
                            setSelectedRoles(selectedRoles);
                            setIsRemoveFinalBeneficiary(
                                checkFinalRelationship(originData, selectedRoles, RelationshipType.Beneficiary)
                            );
                        } else {
                            selectedRoles = selectedRoles.filter((ele) => ele != RelationshipType.Beneficiary);
                            setSelectedRoles(selectedRoles);
                            setIsRemoveFinalBeneficiary(
                                checkFinalRelationship(originData, selectedRoles, RelationshipType.Beneficiary)
                            );
                        }
                    },
                },
            ];
        } else if (relationship == RelationshipType.Settlor) {
            // Settlor only
            return [
                {
                    label: RelationshipTypeMap[RelationshipType.Settlor],
                    disabled: true,
                    value: selectedRoles.includes(RelationshipType.Settlor),
                    onChange: (v) => {},
                },
                {
                    label: RelationshipTypeMap[RelationshipType.IndividualTrustee],
                    disabled: false,
                    value: selectedRoles.includes(RelationshipType.IndividualTrustee),
                    onChange: (v) => {
                        if (v) {
                            selectedRoles = selectedRoles.concat(RelationshipType.IndividualTrustee);
                            setSelectedRoles(selectedRoles);
                            setIsTrusteeSmallerThanSettlor(checkTrusteeIsSmallerThanSettlor(originData, selectedRoles));
                        } else {
                            selectedRoles = selectedRoles.filter((ele) => ele != RelationshipType.IndividualTrustee);
                            setSelectedRoles(selectedRoles);
                            setIsTrusteeSmallerThanSettlor(checkTrusteeIsSmallerThanSettlor(originData, selectedRoles));
                        }
                    },
                },
            ];
        }
    } else if (relationships.length === 2) {
        if (relationships.includes(RelationshipType.Settlor)) {
            // trsutee & settlor
            return [
                {
                    label: RelationshipTypeMap[RelationshipType.IndividualTrustee],
                    disabled: isLastTrustee,
                    value: selectedRoles.includes(RelationshipType.IndividualTrustee),
                    onChange: (v) => {
                        if (v) {
                            selectedRoles = selectedRoles.concat(RelationshipType.IndividualTrustee);
                            setSelectedRoles(selectedRoles);
                            setIsTrusteeSmallerThanSettlor(checkTrusteeIsSmallerThanSettlor(originData, selectedRoles));
                        } else {
                            selectedRoles = selectedRoles.filter((ele) => ele != RelationshipType.IndividualTrustee);
                            setSelectedRoles(selectedRoles);
                            setIsTrusteeSmallerThanSettlor(checkTrusteeIsSmallerThanSettlor(originData, selectedRoles));
                        }
                    },
                },
                {
                    label: RelationshipTypeMap[RelationshipType.Settlor],
                    disabled: false,
                    value: selectedRoles.includes(RelationshipType.Settlor),
                    onChange: (v) => {
                        if (v) {
                            selectedRoles = selectedRoles.concat(RelationshipType.Settlor);
                            setSelectedRoles(selectedRoles);
                            setIsTrusteeSmallerThanSettlor(checkTrusteeIsSmallerThanSettlor(originData, selectedRoles));
                            setIsRemoveFinalSettlor(
                                checkFinalRelationship(originData, selectedRoles, RelationshipType.Settlor)
                            );
                        } else {
                            selectedRoles = selectedRoles.filter((ele) => ele != RelationshipType.Settlor);
                            setSelectedRoles(selectedRoles);
                            setIsTrusteeSmallerThanSettlor(checkTrusteeIsSmallerThanSettlor(originData, selectedRoles));
                            setIsRemoveFinalSettlor(
                                checkFinalRelationship(originData, selectedRoles, RelationshipType.Settlor)
                            );
                        }
                    },
                },
            ];
        } else if (relationships.includes(RelationshipType.Beneficiary)) {
            return [
                {
                    label: RelationshipTypeMap[RelationshipType.IndividualTrustee],
                    disabled: true,
                    value: selectedRoles.includes(RelationshipType.IndividualTrustee),
                    onChange: (v) => {},
                },
                {
                    label: RelationshipTypeMap[RelationshipType.Beneficiary],
                    disabled: selectedRoles.length >= 2 && !selectedRoles.includes(RelationshipType.Beneficiary),
                    value: selectedRoles.includes(RelationshipType.Beneficiary),
                    onChange: (v) => {
                        if (v) {
                            selectedRoles = selectedRoles.concat(RelationshipType.Beneficiary);
                            setSelectedRoles(selectedRoles);
                            setIsRemoveFinalBeneficiary(
                                checkFinalRelationship(originData, selectedRoles, RelationshipType.Beneficiary)
                            );
                        } else {
                            selectedRoles = selectedRoles.filter((ele) => ele != RelationshipType.Beneficiary);
                            setSelectedRoles(selectedRoles);
                            setIsRemoveFinalBeneficiary(
                                checkFinalRelationship(originData, selectedRoles, RelationshipType.Beneficiary)
                            );
                        }
                    },
                },
                {
                    label: RelationshipTypeMap[RelationshipType.Settlor],
                    disabled:
                        (selectedRoles.length >= 2 && !selectedRoles.includes(RelationshipType.Settlor)) ||
                        isTwoSettlors,
                    value: selectedRoles.includes(RelationshipType.Settlor),
                    onChange: (v) => {
                        if (v) {
                            setIsSettlorAdded(true);
                            selectedRoles = selectedRoles.concat(RelationshipType.Settlor);
                            setSelectedRoles(selectedRoles);
                            setIsTrusteeSmallerThanSettlor(checkTrusteeIsSmallerThanSettlor(originData, selectedRoles));
                            setIsRemoveFinalSettlor(
                                checkFinalRelationship(originData, selectedRoles, RelationshipType.Settlor)
                            );
                        } else {
                            setIsSettlorAdded(false);
                            selectedRoles = selectedRoles.filter((ele) => ele != RelationshipType.Settlor);
                            setSelectedRoles(selectedRoles);
                            setIsTrusteeSmallerThanSettlor(checkTrusteeIsSmallerThanSettlor(originData, selectedRoles));
                            setIsRemoveFinalSettlor(
                                checkFinalRelationship(originData, selectedRoles, RelationshipType.Settlor)
                            );
                        }
                    },
                },
            ];
        }
    }
    return [];
};

export const EditRolesLightbox = (props: IEditRolesLightbox) => {
    const [selectedRoles, setSelectedRoles] = React.useState(props.editItem.Relationships || []);
    const [isSettlorAdded, setIsSettlorAdded] = useState(false);
    const [isTrusteeSmallerThanSettlor, setIsTrusteeSmallerThanSettlor] = useState(false);
    const [isRemoveFinalSettlor, setIsRemoveFinalSettlor] = useState(false);
    const [isRemoveFinalBeneficiary, setIsRemoveFinalBeneficiary] = useState(false);
    const isTwoSettlors = checkSettlorEqualOrGreaterThanTwo(props.data, []);
    const isLastTrustee =
        props.data.filter((ele) => {
            return ele.Relationships.includes(RelationshipType.IndividualTrustee);
        }).length == 1;

    return (
        <Lightbox
            cssWrapper="is-default-lightbox"
            onClose={() => props.onClose()}
            show={true}
            title={"Trust Servicing - Edit Role(s)"}
        >
            <h3>Trust member</h3>
            <br />
            {TitleMap.getString(props.editItem?.Individual?.PersonalDetails?.Title) +
                " " +
                props.editItem?.Individual?.PersonalDetails?.GivenName +
                " " +
                props.editItem?.Individual?.PersonalDetails?.FamilyName}
            {isSettlorAdded && (
                <Alert alertType={AlertType.Warning} message={OrganisationMemberPopUpInfo.settlorToolTip} />
            )}
            {isTrusteeSmallerThanSettlor && (
                <Alert alertType={AlertType.Warning} message={OrganisationMemberPopUpInfo.moreTrusteesThanSettlors} />
            )}
            {isRemoveFinalSettlor && (
                <Alert
                    alertType={AlertType.Warning}
                    message={
                        OrganisationMemberPopUpInfo.line2 + " A settlor will be required if this is a 'New' Trust."
                    }
                />
            )}
            {isRemoveFinalBeneficiary && (
                <Alert alertType={AlertType.Warning} message={OrganisationMemberPopUpInfo.noBeneficiary} />
            )}
            {selectedRoles.length === 0 && (
                <Alert alertType={AlertType.Warning} message={OrganisationMemberPopUpInfo.removeBoth} />
            )}
            <CheckboxGroup
                type="block"
                wrapCss="mb-0"
                options={getCheckboxOptions(
                    props.data.filter((ele) => ele.CustomerId != props.editItem?.CustomerId),
                    props.editItem,
                    selectedRoles,
                    setSelectedRoles,
                    setIsSettlorAdded,
                    setIsTrusteeSmallerThanSettlor,
                    setIsRemoveFinalSettlor,
                    setIsRemoveFinalBeneficiary,
                    isLastTrustee,
                    isTwoSettlors
                )}
            />
            <br />
            <button className="btn secondary mr-10" onClick={() => props.onClose()}>
                Cancel
            </button>
            <button
                className="btn primary"
                onClick={() => {
                    props.onSave(props.editItem, selectedRoles);
                }}
            >
                Save
            </button>
        </Lightbox>
    );
};
